export enum ForgotPasswordStepEnum {
  REQUEST_OTP = 'REQUEST_OTP',
  ENTER_OTP = 'ENTER_OTP',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  COMPLETED = 'COMPLETED'
}
